module.exports = __webpack_public_path__ + "d1be07396a6480ae720143f6a62ecc4a.pdf";